import numeral from 'numeral'
import {ProductCalc} from '@/utils/functions/Product'

const regular = (value, fixed = 2) => {
    const numb = parseFloat(value)
    if (isNaN(numb)) return '0,00'
    return numb.toFixed(fixed)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        .replace('.', ',')
}

const regularFromTon = (value, fixed = 2) => {
    const numb = parseFloat(value)
    if (isNaN(numb)) return '0,00'
    const tmp = numb.toFixed(fixed)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        .split('.')
    const first = (tmp[0] || '')
    const second = tmp[1].replace(' ', '')
    return `${first},${second}`
}

export const price = value => regular(value, 2) + ' сум'
export const ton = value => regularFromTon(value, 4) + ' т'
export const liter = value => regular(value, 1) + ' л'
export const density = value => regular(value, 3) + ' кг/м3'
export const vatRateFilter = value => numeral(value).format('0') + ' %'


export const vatRate = (product) => {
    return vatRateFilter(product.VATRate)
}

// double VATPerTonne  // nds za tonnu
export const nds = (product) => {
    const nds = ProductCalc.Nds(product)
    product.VATPerTonne = nds
    return price(nds)
}

// double NetPricePerTonne // chistaya sena bez Excise i nds za tonnu
export const priceClearPrice = (product) => {
    const netPrice = ProductCalc.PriceClearTon(product)
    product.NetPricePerTonne = netPrice
    return price(netPrice)
}

export const appendixTotalCalculate = (product) => {
    const result = ProductCalc.AppendixTotalCalculate(product)
    return price(parseFloat(result).toFixed(0))
}

export const priceClearPrices = (product) => {
    const totalPrice = ProductCalc.PriceClearTons(product)
    return price(totalPrice)
}

export const excise = (product) => {
    const totalExcise = ProductCalc.TotalExcise(product)
    return price(totalExcise)
}

export const totalNds = (product) => {
    const totalNds = ProductCalc.TotalNds(product)
    return price(totalNds)
}


export const totalPrice = (product) => {
    const cost = ProductCalc.TotalPrice(product)
    return price(cost)
}

export const totalPrice2 = (product) => {
    const cost = ProductCalc.TotalPrice(product)
    return price(parseFloat(cost).toFixed(0))
}

// double PricePerTonneNoVAT // sena za tonu(chistaya sena +Excise) bez nds
export const priceClearNdsPrice = (product) => {
    const cost = ProductCalc.PriceClearNdsPrice(product)
    product.PricePerTonneNoVAT = cost
    return price(cost)
}

export const priceClearNdsPrices = (product) => {
    const cost = ProductCalc.PriceClearNdsPrices(product)
    return price(cost)
}
